import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const TABLET_BREAKPOINT_PX = 1024

export const Backdrop = styled.div<{ $open: boolean }>`
  display: none;

  @media (max-width: ${TABLET_BREAKPOINT_PX}px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(4px);
    z-index: 10001;
    opacity: ${(props) => (props.$open ? 1 : 0)};
    pointer-events: ${(props) => (props.$open ? 'auto' : 'none')};
    transition: opacity 0.3s ease;
  }
`

export const Drawer = styled.aside<{ $open: boolean }>`
  display: none;

  @media (max-width: ${TABLET_BREAKPOINT_PX}px) {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 17rem;
    max-width: 85vw;
    z-index: 10002;
    background: ${tokens.surface.raised};
    border-right: 1px solid ${tokens.border.hairline};
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.4);
    transform: translateX(${(props) => (props.$open ? '0' : '-100%')});
    transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    overflow: hidden;
  }
`

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid ${tokens.border.hairline};
  flex-shrink: 0;
`

export const DrawerLogo = styled.div`
  display: flex;
  align-items: center;
`

export const DrawerCloseBtn = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid ${tokens.border.hairline};
  background: transparent;
  color: ${tokens.text.primary};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: filter 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  svg {
    width: 22px;
    height: 22px;
  }

  &:hover {
    border-color: ${tokens.accent.base};
    color: ${tokens.accent.base};
  }
`

export const DrawerNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 1rem;
  overflow-y: auto;
  flex: 1;

  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${tokens.border.hairline};
    border-radius: 3px;
  }
`

export const DrawerGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const DrawerLink = styled.div<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0.75rem 0.875rem;
  border-radius: 10px;
  cursor: pointer;
  color: ${(props) => (props.$active ? '#1e1e1e' : tokens.text.primary)};
  background: ${(props) => (props.$active ? tokens.accent.base : 'transparent')};
  transition: background 0.2s ease, color 0.2s ease;
  text-transform: capitalize;
  font-weight: 500;
  font-size: calc(0.95rem + 2px);

  .icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => (props.$active ? '#1e1e1e' : tokens.text.primary)};
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }

  .label {
    flex: 1;
  }

  .chev {
    display: flex;
    align-items: center;
    transition: transform 0.2s ease;
  }

  &:hover {
    background: ${(props) =>
      props.$active ? tokens.accent.base : tokens.border.hairline + '50'};
  }
`

export const DrawerSubLink = styled.div<{ $active: boolean }>`
  padding: 0.625rem 0.875rem 0.625rem 3rem;
  border-radius: 10px;
  cursor: pointer;
  font-size: calc(0.875rem + 2px);
  text-transform: capitalize;
  color: ${(props) => (props.$active ? tokens.accent.base : tokens.text.primary)};
  background: ${(props) =>
    props.$active ? tokens.accent.base + '20' : 'transparent'};
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${tokens.border.hairline + '50'};
  }
`

export const ChevronWrap = styled.span<{ $open: boolean }>`
  display: inline-flex;
  transition: transform 0.2s ease;
  transform: ${(props) => (props.$open ? 'rotate(180deg)' : 'rotate(0deg)')};
`
